import { parse, print, visit } from 'graphql';
import sortBy from 'lodash/sortBy.js';
function getName(selection) {
    return selection.kind === 'InlineFragment'
        ? selection.typeCondition
            ? selection.typeCondition.name.value
            : ''
        : selection.name.value;
}
export function filterBuiltin(selections) {
    return selections.filter((selection) => {
        const name = getName(selection);
        return name === '_id' || !name.startsWith('_');
    });
}
export function sortByName(selections) {
    return sortBy(selections, getName);
}
export function sortArgs(selections) {
    return selections.map((selection) => {
        if ('arguments' in selection) {
            return {
                ...selection,
                arguments: sortBy(selection.arguments, (arg) => arg.name.value)
            };
        }
        return selection;
    });
}
function transformSelectionSets(ast, transforms) {
    return visit(ast, {
        enter(node) {
            if ('selectionSet' in node && node.selectionSet) {
                let selections = node.selectionSet.selections;
                for (const transform of transforms) {
                    selections = transform(selections);
                }
                if (selections.length === 0) {
                    return null;
                }
                return {
                    ...node,
                    selectionSet: {
                        ...node.selectionSet,
                        selections
                    }
                };
            }
        }
    });
}
export function prettifyQuery(query, transforms = [filterBuiltin, sortByName]) {
    const doc = parse(query, { noLocation: true });
    const transformed = transformSelectionSets(doc, transforms);
    return print(transformed);
}
